import { GET_REPORT_PREVIEW_DATA } from "../../../api/apiPath";
import http from "../../../api/server";
import { CHUNK_PAGE_SIZE } from "../model/pageTypes";

export async function fetchReportPreviewChunk({
  propertyMasterId,
  inspectionReferenceNumber,
  pageNumber,
  pageSize = CHUNK_PAGE_SIZE,
}) {
  const params = new URLSearchParams();
  params.append("PropertyId", propertyMasterId);
  params.append("InspectionReferenceNumber", inspectionReferenceNumber);
  params.append("PageNumber", String(pageNumber));
  params.append("PageSize", String(pageSize));

  const response = await http.post(
    `${GET_REPORT_PREVIEW_DATA}?${params.toString()}`,
  );

  if (response?.status === 200) {
    return response.data;
  }
  throw new Error(`Report preview fetch failed: ${response?.status}`);
}
